module.exports = __webpack_public_path__ + "img/costIndexIcon.fe96bf13.png";